// Import api models.
import {
	Mortgagee,
} from '@app/models/api';
import ComparisonSummaryEntities, {
	ComparisonSummaryEntitiesParameters
} from './ComparisonSummaryEntities';

interface ComparisonSummaryMortgageesParameters extends ComparisonSummaryEntitiesParameters<Mortgagee> {

}

export default class ComparisonSummaryMortgagees extends ComparisonSummaryEntities<Mortgagee> {
	public constructor(params: ComparisonSummaryMortgageesParameters) {
		super(params);
	}

}